module.exports = __webpack_public_path__ + "static/img/m-dire3.eda3b2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/m-dire3.jpg
// module id = hd/W
// module chunks = 1